module.exports = __webpack_public_path__ + "static/NetworkSecurity-21748a7a01b35b6760ebd905a2a57833.svg";